/**
 * @deprecated This file is deprecated and in migration to the new analytics architecture.
 * @see {@link ../analytics/README.md} for the new analytics system.
 * @todo Migrate to the new analytics system in src/core/analytics/
 */
import { useEffect } from "react";

import { useGetTrackingParams, useSetupAnalytics } from "@core/application/analytics-use-cases";

const AnalyticsRoot = (): null => {
  const setupAnalytics = useSetupAnalytics();
  const getTrackingParams = useGetTrackingParams();

  useEffect(() => {
    const initialize = async () => {
      await setupAnalytics;
      getTrackingParams();
    };

    void initialize();
  }, [setupAnalytics, getTrackingParams]);

  return null;
};

export default AnalyticsRoot;
